module.exports = __webpack_public_path__ + "img/non-favorite.c78e8a9a.svg";